'use client'

import s from '../style.module.scss'
import clsx from 'clsx'
import HeartIcon from './heart-icon'
import {useUserGamePreference} from '@app/components/fav-page/preference-provider/preference-provider'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

type Props = {
  gameCode: string
  gameNameEn: string
}

const FavBtnClient = ({gameCode, gameNameEn}: Props) => {
  const {userPreference, addFav, removeFav} = useUserGamePreference()
  const isFav = userPreference.favourite.includes(gameCode)

  const handleClick = () => {
    isFav ? removeFav(gameCode) : addFav(gameCode)
    triggerAnalytics('game-card-favorited', {
      'game-name': gameNameEn,
      'game-code': gameCode,
      favourite: !isFav,
    }).sendAll()
  }

  return (
    <button onClick={handleClick} className={s.button}>
      <HeartIcon
        className={clsx(s.icon, {
          [s.heart_animation]: isFav,
        })}
        filled={isFav}
      />
    </button>
  )
}

export default FavBtnClient
